<template>
    <div class="p-col-12 p-md-10 p-mx-auto p-mt-4 p-grid">
        <div class="p-col-1 p-md-1">
            <Button icon="pi pi-clock" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu"/>
            <Menu id="overlay_menu" ref="search_timerange_menu" :model="searchOptions.timeRangeMenuOptions" :popup="true" />
        </div>
        <div v-if="searchForm.selectedTimeRangeMenu === 'relative'" class="p-col-10 p-md-4">
            <Dropdown optionLabel="label" placeholder="Time range"
                v-model="searchForm.selectedRelativeOption"
                :options="searchOptions.relativeOptions"
                style="width:100%" class="p-text-left" />
        </div>
        <div v-else-if="searchForm.selectedTimeRangeMenu === 'absolute'" class="p-col-12 p-md-6">
            <div class="p-grid">
                <Calendar id="search_from" class="p-col-12 p-md-6"
                    v-model="searchForm.from"
                    placeholder="From"
                    :showTime="true" :showSeconds="true" :maxDate="searchForm.to"
                    dateFormat="dd/mm/yy" hourFormat="HH:mm:ss" />
                
                <Calendar id="search_to" class="p-col-12 p-md-6"
                    v-model="searchForm.to"
                    placeholder="To"
                    :showTime="true" :showSeconds="true" :minDate="searchForm.from"
                    dateFormat="dd/mm/yy" hourFormat="HH:mm:ss" />
            </div>
        </div>
    </div>
    <div class="p-col-12 p-md-10 p-mx-auto p-grid">
        <div class="p-col-1 p-md-1">
            <Button icon="pi pi-search" class="p-button-success p-button-lg"
                :loading="searchForm.isLoading"
                @click="search()" />
        </div>
        <div class="p-col-10 p-md-10">
            <span class="" style="width:100%">
                <InputText v-model="searchForm.query" :disabled="searchForm.isLoading"
                    id="query" type="text" placeholder="Search query"
                    class="p-inputtext-lg"
                    @keyup.enter="search()"
                    style="width:100%" />
            </span>
        </div>
        <div class="p-col-1 p-md-1">
            <Button
                v-show="searchForm.query !== null"
                icon="pi pi-times"
                @click="clearSearchForm()"
                class="p-offset-2 p-col-2 p-md-2 p-button-secondary p-button-text p-button-rounded p-button-lg" />
        </div>
    </div>

    <!-- logs list -->
    <div class="p-grid p-mx-auto p-mt-4">
        <div class="p-col-12 p-md-10 p-mx-auto">
            <ProgressBar mode="indeterminate" v-show="logs.isLoading" style="height: .2em" />

            <Paginator v-if="!logs.isLoading && logs.items !== undefined && logs.items !== null && logs.items.length > 0"
                :rows="logs.itemPerPage"
                :rowsPerPageOptions="logs.itemsPerPageOptions"
                :totalRecords="logs.totalCount"
                :first="logs.firstItemIndex"
                @page="onPage($event)" >
                <template #start>
                    {{ logs.totalCount }} {{logs.totalCount > 1 ? 'logs' : 'log'}} found
                </template>
                <template #end="slotProps">
                    Page: {{(slotProps.state.page + 1)}} / {{ Math.ceil(logs.totalCount / logs.itemPerPage) }}
                </template>
            </Paginator>

            <div v-if="!logs.isLoading && logs.items !== undefined && logs.items !== null && logs.items.length > 0"
                class="p-mt-4">
                <div v-for="item in logs.items" :key="item.id"
                    class="p-grid p-card p-mt-2">
                    <div class="p-col-2 p-md-2 p-text-center">
                        <div v-if="item.is_error !== undefined">
                            <i v-if="!item.is_error" class="pi pi-check-circle" style="color:green"></i>
                            <i v-else class="pi pi-times-circle" style="color:red"></i>
                            <span style="color:#CCC; margin-left:10px">
                                <small>#</small>{{item.id}}
                            </span>
                        </div>
                        <span style="color:#AAA; font-size:0.9rem">{{item.log_date}}</span>
                    </div>
                    <div class="p-col-10 p-md-10 p-text-left p-grid" style="cursor:pointer">
                        <div class="p-col-12 p-md-12"
                            @click="item.is_details_visible = (!item.is_details_visible ?? true)">
                            <!-- log message -->
                            <span class="log-short-message"
                                v-if="item.log !== undefined && item.log !== null
                                && item.log.message !== undefined && item.log.message !== null">
                                <span v-if="item.log.message.message !== undefined && item.log.message.message !== null">{{item.log.message.message}}</span>
                                <span v-else>{{ item.log.message }}</span>
                            </span>
                            <span class="log-short-message"
                                v-else-if="item.log !== undefined && item.log !== null
                                && item.log.error !== undefined && item.log.error !== null
                                && (typeof item.log.error === 'string' || item.log.error instanceof String)">
                                <span>{{item.log.error}}</span>
                            </span>
                            <span class="log-short-message"
                                v-else>
                                <span v-if="item.is_error !== undefined && !item.is_error">İşlem başarılı</span>
                                <span v-else>İşlem başarısız veya hatalı</span>
                            </span>

                            <!-- preview enabled keys -->
                            <div v-if="!item.is_details_visible && item.preview_log_keys !== undefined && item.preview_log_keys !== null && item.preview_log_keys.length > 0"
                                class="p-mt-2">
                                <span class="log-object-preview" v-for="previewKey in item.preview_log_keys" :key="previewKey.key">
                                    <span v-if="previewKey.showKey" class="log-object-preview-key log-object-preview-left-radius">{{previewKey.key}}</span>
                                    <span class="log-object-preview-value log-object-preview-right-radius"
                                        :class="!previewKey.showKey ? 'log-object-preview-left-radius' : ''">{{previewKey.value}}</span>
                                </span>
                            </div>
                        </div>
                        <div v-if="item.is_details_visible !== undefined && item.is_details_visible"
                            class="p-col-12 p-md-7">
                            <div v-for="log_object in item.log_array" :key="log_object.key" style="">
                                <Button class="p-button-sm p-button-rounded p-button-text p-button-secondary p-button-outlined"
                                    @click="addToQuery(log_object)"
                                    icon="pi pi-plus" />
                                <Tag :value="log_object.key" severity="info" class="log-object-tag" />
                                <span v-if="log_object.value !== undefined && log_object.value !== null"
                                    class="log-object-value">
                                    {{log_object.value}}
                                </span>
                                <span v-else class="log-object-value-null">
                                    null
                                </span>
                            </div>
                        </div>
                        <div v-if="item.is_details_visible !== undefined && item.is_details_visible"
                            class="p-col-12 p-md-5">
                            <json-viewer
                                :value="item.log"
                                :expand-depth="3"
                                theme="json-viewer-theme"
                                :copyable="{ copyText: 'Copy', copiedText: 'Copied', timeout: 3000 }"
                                expanded />
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="logs.items === undefined || logs.items === null || logs.items.length === 0">
                <p>
                    No result found
                </p>
            </div>

            <Paginator v-if="!logs.isLoading && logs.items !== undefined && logs.items !== null && logs.items.length > 5"
                :rows="logs.itemPerPage"
                :rowsPerPageOptions="logs.itemsPerPageOptions"
                :totalRecords="logs.totalCount"
                :first="logs.firstItemIndex"
                @page="onPage($event)"
                class="p-mt-4">
                <template #start>
                    {{ logs.totalCount }} logs found
                </template>
                <template #end="slotProps">
                    Page: {{(slotProps.state.page + 1)}} / {{ Math.ceil(logs.totalCount / logs.itemPerPage) }}
                </template>
            </Paginator>
        </div>
    </div>

</template>

<style>
.log-short-message {
    color: #DDD;
    font-family: Consolas, Menlo, Monaco;
    font-size: 0.9rem;
}
.log-short-message:hover {
    color: #FFF;
}
.log-object-value {
    color: #FAFAFA;
    font-family: Consolas, Menlo, Monaco;
    font-size:0.9rem;
}
.log-object-value-null {
    color:coral;
    font-family: Consolas, Menlo, Monaco;
    font-size:0.9rem;
}
.log-object-tag {
    background-color:cadetblue;
    color:#222;
    margin:5px;
}
.log-object-summary-key {
    background-color:cadetblue;
    color:#222;
    margin:5px;
}
.log-object-summary-value {
    font-size: 0.75rem;
    font-family: Consolas, Menlo, Monaco;
    color: cadetblue;
}
.log-object-preview {
    font-size: 0.8rem;
    margin: 0px 4px;
}
.log-object-preview-key {
    padding: 4px;
    background:darkslategray;
    color:#CCC;
}
.log-object-preview-value {
    padding: 4px 10px;
    background-color:cadetblue;
    color:#222;
    font-weight: 900;
}
.log-object-preview-left-radius {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.log-object-preview-right-radius {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>

<script>
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import ProgressBar from 'primevue/progressbar'
import Tag from 'primevue/tag'
import Paginator from 'primevue/paginator'
import Calendar from 'primevue/calendar'
import Menu from 'primevue/menu'
import Dropdown from 'primevue/dropdown'

import Const from '../utils/const'
import dayjs from 'dayjs'

export default {
    name: 'LogManagement',
    components: {
        InputText, Button, ProgressBar, Tag, Paginator, Calendar, Menu, Dropdown
    },
    data() {
        return {
            searchOptions: {
                timeRangeMenuOptions: [
                    {
                        label: 'Relative',
                        icon: 'pi pi-bookmark',
                        command: () => {
                            this.timeRangeSelected('relative')
                        }
                    },
                    {
                        label: 'Absolute',
                        icon: 'pi pi-calendar',
                        command: () => {
                            this.timeRangeSelected('absolute')
                        }
                    }
                ],
                relativeOptions: [
                    {
                        label: 'Last 1 minute',
                        value: 1
                    },{
                        label: 'Last 5 minutes',
                        value: 5
                    },{
                        label: 'Last 10 minutes',
                        value: 10
                    },{
                        label: 'Last 15 minutes',
                        value: 15
                    },{
                        label: 'Last 30 minutes',
                        value: 30
                    },{
                        label: 'Last 1 hour',
                        value: 60
                    },{
                        label: 'Last 2 hours',
                        value: 120
                    },{
                        label: 'Last 8 hours',
                        value: 480
                    },{
                        label: 'Last 1 day',
                        value: 1440
                    },{
                        label: 'Last 2 days',
                        value: 2880
                    },{
                        label: 'Last 5 days',
                        value: 7200
                    },{
                        label: 'Last 7 days',
                        value: 10080
                    },{
                        label: 'Last 14 days',
                        value: 20160
                    },{
                        label: 'All messages',
                        value: 0
                    }
                ]
            },
            searchForm: {
                query: null,
                isLoading: false,
                from: null,
                to: null,
                selectedRelativeOption: null,
                selectedTimeRangeMenu: 'relative'
            },
            logs: {
                items: [],
                currentPage: 1,
                totalCount: undefined,
                itemPerPage: undefined,
                itemsPerPageOptions: [10, 20, 30, 50],
                isLoading: false,
                firstItemIndex: undefined
            },
            previewEnabledProperties: [
                { key: "cronjob", showKey: false },
                { key: "trigger", showKey: true },
                { key: "function", showKey: true },
                { key: "total_added_count", showKey: true },
                { key: "total_updated_count", showKey: true },
                { key: "total_found_news_count", showKey: true },
            ]
        }
    },
    emits: ['loginResult', 'pageLoaded'],
    beforeMount() {
        this.$emit('pageLoaded', {
            title: 'Log Management'
        })

        this.searchForm.selectedRelativeOption = this.searchOptions.relativeOptions[5]
    },
    mounted() {
        this.search()
    },
    methods: {
        async getLogs(query, page, limit = null, callback = null) {
            let self = this,
                searchForm = self.searchForm,
                logs = self.logs,
                toast = self.$toast,
                cookies = self.$cookies,
                token = cookies.get('token');
            
            try {
                logs.isLoading = true

                var searchFrom = searchForm.from
                if(searchForm.selectedTimeRangeMenu === 'relative') {
                    searchFrom = null
                    if(searchForm.selectedRelativeOption !== null && searchForm.selectedRelativeOption.value !== 0) {
                        searchFrom = dayjs(new Date()).subtract(searchForm.selectedRelativeOption.value, 'minute').format('YYYY-MM-DD HH:mm:ss')
                    }
                }

                var searchTo = searchForm.to
                if(searchForm.selectedTimeRangeMenu === 'relative') {
                    searchTo = dayjs().format('YYYY-MM-DD HH:mm:ss')
                }

                let response = await self.$http.get('api/logs', {
                    params: {
                        query: query,
                        page: page,
                        limit: limit,
                        from: searchFrom,
                        to: searchTo
                    },
                    headers: {
                        'authorization': 'Bearer ' + token
                    }
                })

                cookies.set("token", response.headers['refresh-token']);

                if(response.data.kod === Const.KOD.oturumSonlandi) {
                    self.$router.push('/login')
                } else if(response.data.kod !== 0) {
                    let mesaj = response.data.mesaj ?? 'Api error. \'mesaj\' not found in response'
                    self.$toast.add({severity:'warning', summary: 'Error', detail: mesaj, life: 3000})
                    return
                }

                logs.items = response.data.items
                logs.itemPerPage = response.data.itemPerPage
                logs.totalCount = response.data.totalCount
                logs.currentPage = page
                logs.firstItemIndex = (logs.currentPage - 1) * logs.itemPerPage

                if(logs.items !== null) {
                    logs.items.forEach(item => {
                        item.log_date = dayjs(new Date(item.log_date)).format('DD/MM/YYYY HH:mm:ss');

                        // json log icerigini key-value dizisine dönüstür
                        var log_array = []
                        for(let [key, value] of Object.entries(item.log)) {
                            log_array.push({key: key, value: value})
                        }
                        item.log_array = log_array

                        // log iceriginde preview enabled olan keyleri olustur
                        item.preview_log_keys = this.generatePreviewEnabledKeys(item.log)
                    })
                }
            } catch(error) {
                console.log(error)
                toast.add({severity:'error', summary: 'Error', detail:error})
            } finally {
                logs.isLoading = false

                if(callback !== undefined && callback !== null) {
                    callback()
                }
            }
        },
        async search() {
            let self = this,
                searchForm = self.searchForm
            
            searchForm.isLoading = true
            this.getLogs(searchForm.query, 1, self.logs.itemPerPage, () => {
                searchForm.isLoading = false
            })
        },
        async onPage(event) {
            let searchForm = this.searchForm,
                page = event.page + 1

            searchForm.isLoading = true
            this.getLogs(searchForm.query, page, event.rows, () => {
                searchForm.isLoading = false
            })
        },
        clearSearchForm() {
            this.searchForm.query = null
            this.searchForm.isLoading = false
        },
        addToQuery(logObject) {
            let key = logObject.key,
                value = logObject.value

            var errorMessage = null

            if(key === undefined && key === null && key === '') {
                errorMessage = 'Log key is empty!'
            } else if(value === undefined && value === null && value === '') {
                errorMessage = 'Value is empty!'
            }

            if(errorMessage !== null) {
                this.$toast.add({severity:'warn', summary: 'Error', detail: errorMessage, life: 3000});
                return
            }

            if(this.searchForm.query !== undefined && this.searchForm.query !== null && this.searchForm.query.length > 0) {
                this.searchForm.query = `${this.searchForm.query} AND`
            }

            this.searchForm.query = `${(this.searchForm.query ?? '')} ${key}:${value}`.trim()
        },
        toggle(event) {
            this.$refs.search_timerange_menu.toggle(event);
        },
        timeRangeSelected(timeRange) {
            let self = this

            self.searchForm.selectedTimeRangeMenu = timeRange

            if(timeRange === 'absolute') {
                this.searchForm.from = null
                this.searchForm.to = null
            } else {
                this.selectedRelativeOption = null
            }
        },
        generatePreviewEnabledKeys(logObject) {
            if(logObject === undefined || logObject === null) {
                return null;
            }

            let logProperties = []

            for(let property of this.previewEnabledProperties) {
                if(logObject[property.key] !== undefined && logObject[property.key] !== null) {
                    logProperties.push({
                        key: property.key,
                        value: logObject[property.key],
                        showKey: property.showKey
                    })
                }
            }

            return logProperties
        }
    }
}

</script>